import HeaderBar from "../../../components/header/headerBar";
import { TextBox, Input } from "../../../components/textfield";
import SelectField from "../../../components/select/selectField";
import MainButton from "../../../components/button/mainButton";
import Icon from "@mdi/react";
import { mdiPrinter } from "@mdi/js";
import { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";

interface ParamTypes {
  id: string;
}

const Refund = () => {
  const nevigate = useHistory();
  const { id } = useParams<ParamTypes>();

  const [rfdNo, setRfdNo] = useState<string>("");
  const [isSo, setIsSo] = useState<string>("");
  const [channelCustomer, setChannelCustomer] = useState<string>("");
  const [dateCourse, setDateCourse] = useState<string>("");
  const [amountCourse, setAmountCourse] = useState<string>("");
  const [procedureName, setProcedureName] = useState<string>("");
  const [lastDate, setLastDate] = useState<string>("");
  const [balanceAmount, setBalanceAmount] = useState<string>("");
  const [refNo, setRefNo] = useState<string>("");
  const [amountUsed, setAmountUsed] = useState<string>("");
  const [conSult, setConSult] = useState<string>("");
  const [doctorName, setDoctorName] = useState<string>("");
  const [cause, setCause] = useState<string>("");
  const [dueTo, setDueTo] = useState<string>("");

  const option = [
    { value: "1", name: "1" },
    { value: "2", name: "2" },
    { value: "3", name: "3" },
    { value: "4", name: "4" },
  ];

  const getAPIs = () => {
    setRefNo("xxxxx");
    setIsSo("SO-AE-TEST2CUT");
    setDateCourse("25-11-2563");
    setAmountCourse("23,900.00");
    setProcedureName("Filler (Juvederm Vollift)");
    setLastDate("28-12-2563");
    setRfdNo("EK-CNT60100015-RFD");
    setBalanceAmount("8,200.00");
    setChannelCustomer("น.ส.รังสิมา แซ่หว่าง / EK-CNT60100015");
    setAmountUsed("9/10");
    setDueTo("มีอาการแพ้");
  };

  const Update = () => {
    console.log("UPDATE SUCCESS => ", id);
  };

  useEffect(() => {
    getAPIs();
  }, []);
  return (
    <div>
      <HeaderBar btnBack={true} title="Refund Req" />
      <div
        className="card-view"
        style={{
          margin: "10px 80px",
          padding: "40px 80px",
          flexDirection: "column",
        }}
      >
        <h5>รายละเอียด</h5>
        <div className="row">
          <TextBox className="col-3 mg-10" title="RFD No." value={rfdNo} />
          <TextBox className="col-3 mg-10" title="SO" value={isSo} />
          <Input
            className="col-5 mg-10"
            title="ชื่อลูกค้า/CN"
            value={channelCustomer}
            onChange={(e) => {
              setChannelCustomer(e.target.value);
            }}
          />
        </div>
        <div className="row ">
          <TextBox
            className="col-3 mg-10"
            title="วันที่ซื้อคอร์ส "
            value={dateCourse}
          />
          <TextBox
            className="col-3 mg-10"
            title="จำนวนเงินที่ซื้อคอร์ส"
            value={amountCourse}
          />
          <TextBox
            className="col-5 mg-10"
            title="ชื่อหัตถการ"
            value={procedureName}
          />
        </div>
        <div className="row ">
          <TextBox
            className="col-3  mg-10"
            title="วันที่ใช้ล่าสุด "
            value={lastDate}
          />
          <Input
            className="col-3  mg-10"
            title="จำนวนเงินคงเหลือ"
            value={balanceAmount}
            type="number"
            onChange={(e) => {
              setBalanceAmount(e.target.value);
            }}
          />
          <TextBox className="col-3  mg-10" title="เลขที่ใบยา" value={refNo} />
        </div>
        <div className="row ">
          <TextBox
            className="col-3 mg-10"
            title="จำนวนที่ใช้/คงเหลือ "
            value={amountUsed}
          />
          <SelectField
            className="col-3  mg-10"
            title="ชื่อ Consult"
            placeholder="กรณ์วัฒน์ เกียรติการุณ (ต้น)"
            option={option}
            onChange={(e) => {
              setConSult(e.target.value);
            }}
          />
          <SelectField
            className="col-3  mg-10"
            title="แพทย์ผู้รักษา"
            placeholder="ดร.อภิชญา ธัญญาวุฒิ"
            option={option}
            onChange={(e) => {
              setDoctorName(e.target.value);
            }}
          />
        </div>
        <h5 className="mt-40">สาเหตุ</h5>
        <div className="row">
          <SelectField
            className="col-3  mg-10"
            title="เลือกสาเหตุ"
            placeholder="ด้านสุขภาพ (เช่น ผล Lab ไม่ผ่าน)"
            option={option}
            onChange={(e) => {
              setCause(e.target.value);
            }}
          />
        </div>
        <div className="row">
          <Input
            className="col-12 mg-10"
            title="เนื่องจาก"
            value={dueTo}
            onChange={(e) => {
              setDueTo(e.target.value);
            }}
          />
        </div>
      </div>

      <div className="justify-center mt-20">
        <MainButton
          className="mg-10"
          background="#4285F4"
          title="ปริ้นใบ Refund"
        >
          <Icon path={mdiPrinter} size="20" color="#ffff" />
        </MainButton>
        <MainButton className="mg-10" background="#E76464" title="ยกเลิก" />
        <MainButton className="mg-10" title="บันทึก" onClick={Update} />
      </div>
    </div>
  );
};
export default Refund;
